import React from 'react';
import { IconDownload2Svg } from 'apps/sigma2-ui/src/components/svg/IconDownload2';
import { downloadCSV } from 'apps/sigma2-ui/src/lib/utils/csv-export';
import { CSVRow } from 'apps/sigma2-ui/src/lib/utils/csv-export';

/**
 * Interface for the DownloadButton component props
 * @interface
 * @property {CSVRow[]} data - Array of data rows to be exported as CSV
 * @property {string} filename - Name of the file to be downloaded (without extension)
 * @property {string} [className] - Optional CSS classes to be applied to the button
 */
interface CSVDownloadButtonProps {
  data: CSVRow[];
  filename: string;
  className?: string;
}

/**
 * A button component that triggers a CSV download when clicked
 * @component
 * @param {DownloadButtonProps} props - The component props
 * @param {CSVRow[]} props.data - Array of data rows to be exported as CSV
 * @param {string} props.filename - Name of the file to be downloaded (without extension)
 * @param {string} [props.className] - Optional CSS classes to be applied to the button
 * @returns {JSX.Element} A button element with download functionality
 */
export const CSVDownloadButton: React.FC<CSVDownloadButtonProps> = ({
  data,
  filename,
  className = ''
}) => {
  const handleDownload = () => {
    downloadCSV(data, filename);
  };

  return (
    <button
      onClick={handleDownload}
      className={`inline-flex items-center justify-center rounded-md text-royal-700 bg-white ${className}`}
      aria-label="Download data"
    >
      <IconDownload2Svg />
    </button>
  );
};
